import { render, staticRenderFns } from "./StudentBusDataTable.vue?vue&type=template&id=3a2779f6&scoped=true&"
import script from "./StudentBusDataTable.vue?vue&type=script&lang=js&"
export * from "./StudentBusDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2779f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
